import React from "react";
import { Link } from "react-router-dom";

// Data
import apps from "../../../data/apps.json";

// Components
import Magnetic from "../../Common/Magnetic/Magnetic";

// SCSS
import "./Dock.scss";

const Dock = ({ setHoveredElement, openWindow, openWindows }) => {
  return (
    // Dock
    <footer className="Dock">
      {/* Wrapper */}
      <div className="Dock__Wrapper">
        {apps
          .filter((app) => app.id !== "error")
          .map((app) => (
            // Item
            <Magnetic
              setHoveredElement={setHoveredElement}
              as="button"
              type="button"
              key={app.id}
              onClick={() => {
                if (!app.isExternal) {
                  openWindow(app.id);
                }
              }}
              className="Dock__Item"
            >
              {app.isExternal ? (
                <a href={app.path} target="_blank" rel="noreferrer">
                  <img src={app.icon} alt={app.name} className="Dock__Icon" />
                  <span className="Dock__Name">{app.name}</span>
                  {app.isBadge && <span className="Dock__Badge" />}
                  {openWindows.includes(app.id) && (
                    <span className="Dock__Indicator" />
                  )}
                </a>
              ) : (
                <Link to={app.path}>
                  <img src={app.icon} alt={app.name} className="Dock__Icon" />
                  <span className="Dock__Name">{app.name}</span>
                  {app.isBadge && <span className="Dock__Badge" />}
                  {openWindows.includes(app.id) && (
                    <span className="Dock__Indicator" />
                  )}
                </Link>
              )}
            </Magnetic>
          ))}
      </div>
    </footer>
  );
};

export default Dock;
